import { LoginProviderType } from "@whatslly/types/LoginProviderType";
import { UserType } from "@whatslly/types/User";

export const CONTENT_COMMANDS_PREFIX = "whatslly-content";

export const ContentCommands = {
  ABORT_TRANSACTION: `${CONTENT_COMMANDS_PREFIX}:abort-transaction`,
  RESPONSE: `${CONTENT_COMMANDS_PREFIX}:response`,
  ERROR: `${CONTENT_COMMANDS_PREFIX}:error`,
  AUTH: `${CONTENT_COMMANDS_PREFIX}:content-auth`,
  CHECK_WIDGET_IS_ALIVE: `${CONTENT_COMMANDS_PREFIX}:widget-alive`,
  CONTENT_READY: `${CONTENT_COMMANDS_PREFIX}:content-ready`,
  COUNTRY_CODES_CHANGED: `${CONTENT_COMMANDS_PREFIX}:country-codes-changed`,
  UPDATE_WIDGET_STATUS: `${CONTENT_COMMANDS_PREFIX}:update-widget-status`,
  LOGOUT: `${CONTENT_COMMANDS_PREFIX}:logout`,
  THEME_MODE_SET: `${CONTENT_COMMANDS_PREFIX}:theme-mode-set`,
} as const;

export type ContentCommandsKeysType = keyof typeof ContentCommands;
export type ContentCommandsType = (typeof ContentCommands)[ContentCommandsKeysType];

export type ContentCommandsTypes = {
  [ContentCommands.ABORT_TRANSACTION]: never;
  [ContentCommands.RESPONSE]: never;
  [ContentCommands.ERROR]: never;
  [ContentCommands.AUTH]: (data: {
    active?: boolean;
    navigateToEntryPage?: boolean;
    loggedIn: boolean;
    pod: string;
    extensionVersion: string;
    darkMode?: boolean;
    loginProvider: LoginProviderType;
    user: UserType | undefined;
  }) => void;
  [ContentCommands.LOGOUT]: () => void;
  [ContentCommands.CHECK_WIDGET_IS_ALIVE]: () => void;
  [ContentCommands.CONTENT_READY]: () => void;
  [ContentCommands.COUNTRY_CODES_CHANGED]: () => void;
  [ContentCommands.UPDATE_WIDGET_STATUS]: (data: { status: boolean }) => void;
  [ContentCommands.THEME_MODE_SET]: (data: { darkMode: boolean }) => void;
};
